import type { BriefingsAboutData } from "content-ui/briefings/fetchers/briefingsAboutFetcher";
import { MultiSlideCarousel } from "components/carousel/multiSlide";
import StaticDialogue from "components/staticDialogue/staticDialogue";
import React from "react";

type FeedbackSliderProps = Pick<BriefingsAboutData, "feedbacks">;

const FeedbackSlider = ({ feedbacks }: FeedbackSliderProps) => {
  const slidesMulti = feedbacks.map((item) => {
    return {
      widths: [600, 672, 320],
      component: (
        <StaticDialogue
          topHeading={`${item.authorMainRole}
        ${item.authorSecondaryData} / ${item.author}`}
        >
          <span dangerouslySetInnerHTML={{ __html: item.text }} />
        </StaticDialogue>
      ),
    };
  });

  return (
    <div className={"block"}>
      <MultiSlideCarousel
        slides={slidesMulti}
        mainWrapperClasses={
          "flex flex-col items-center lg:items-start lg:justify-end lg:flex-row"
        }
        containerClasses="w-[320px] md:w-[672px] lg:w-[600px] lg:w-full h-100 min-h-[214px] md:min-h-[100px]"
        slideClasses="h-100 max-[360px]:px-5"
        responsiveGap={[0, 0, 0]}
        belowSlides="prevNext"
        paginationContainerClassesOverride={
          "mt-5 lg:mt-[42px] flex gap-0 mr-[-10px]"
        }
        autoHeight={true}
        autoplay={false}
      />
    </div>
  );
};

export default FeedbackSlider;
